<mat-drawer-container class="example-container" autosize>
    <mat-drawer #drawer class="example-sidenav" mode="side" opened="false">
    </mat-drawer>
    <mat-drawer-content class="example-sidenav-content">
        @if(envP){
        <div class="dev">Entorno de pruebas</div>
        }
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>